module.exports = __webpack_public_path__ + "static/media/play_earn.aa3a6fdb.png";